import { useEffect, useState } from 'react';
import useAxios from './useAxios';

const useFeaturedService = (campus, speaker) => {
    const [featuredService, setFeaturedService] = useState();
    const { get } = useAxios();

    useEffect(() => {
        let endpoint = '/api/cms/GetFeaturedService';

        if (campus) {
            endpoint += `?campus=${campus}`;
        }

        if (speaker) {
            if (endpoint.indexOf('campus') !== -1) {
                endpoint += `&speaker=${speaker}`;
            } else {
                endpoint += `?speaker=${speaker}`;
            }
        }

        (async () => {
            try {
                const response = await get(endpoint);

                if (response) {
                    setFeaturedService(response);
                }
            } catch (e) {
                console.error(`Error fetching featured service - ${e.message}`);
            }
        })();
    }, [get, campus, speaker]);

    return featuredService;
};

export default useFeaturedService;
